import React from 'react';

const EffectiveDepositsSumPercentPerPlayer = () => {
    return (
        <div>

        </div>
    )
}

export default EffectiveDepositsSumPercentPerPlayer;